
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TRegionState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
        rerender1: boolean,
        totalCount: number
    }
    
    
    const initialRegionState: TRegionState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 1,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:"",
        rerender1: false,
        totalCount: 0
    
        
    }
    
    export const regionSlice = createSlice({
        name: 'region',
        initialState:initialRegionState,
        reducers: {
            setRegion: (state:TRegionState, { payload }: PayloadAction<[]>) => {
                state.data=payload
             },
            setPerPage: (state:TRegionState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setTotalCount: (state:TRegionState, {payload}: PayloadAction<number>) => {
                            state.totalCount = payload;
                        },
            setCurrentPage: (state:TRegionState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TRegionState, {payload}: PayloadAction<number>) => {
                state.totalPage = payload
             },
            setSearchTerm: (state:TRegionState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TRegionState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TRegionState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TRegionState, {payload}: PayloadAction<boolean>) => { 
                state.loading=payload
            },
            setRerender: (state:TRegionState, {payload}: PayloadAction<boolean>) => {
                state.rerender1 = payload
             },
        },
    })
    
    
    export const { setRegion,setRerender, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading , setTotalCount  } = regionSlice.actions
    export default regionSlice.reducer
    